import { sessionStorageKeys } from '@/constants/sessionStorageKeys';

const STALE_CHUNK_PATTERNS = [
  'not a valid JavaScript MIME type', // Safari / WebKit
  'Failed to fetch dynamically imported module', // Chrome / Chromium
  'Importing a module script failed', // Firefox
];

/**
 * When a new deploy invalidates hashed chunk URLs, dynamic import() can receive
 * HTML (SPA fallback) instead of JS — browsers throw MIME type errors.
 * A full reload fetches the latest index and chunk map.
 */
function shouldReloadForStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error);
  return STALE_CHUNK_PATTERNS.some(pattern => message.includes(pattern));
}

export function reloadIfStaleChunkError(error: unknown): void {
  if (!shouldReloadForStaleChunkError(error)) {
    return;
  }

  if (sessionStorage.getItem(sessionStorageKeys.staleChunkReloaded)) {
    sessionStorage.removeItem(sessionStorageKeys.staleChunkReloaded);
    return;
  }

  sessionStorage.setItem(sessionStorageKeys.staleChunkReloaded, '1');
  window.location.reload();
}
